import { Link } from 'react-router-dom'

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className={`brand ${compact ? 'brand--compact' : ''}`} aria-label="LIGA UVM — início">
      <picture>
        <source srcSet="/brand/logo-256.webp" type="image/webp" />
        <img src="/brand/logo-192.png" alt="" width="48" height="48" />
      </picture>
      <span>
        <strong>LIGA UVM</strong>
        {!compact ? <small>Palpites de MMA</small> : null}
      </span>
    </Link>
  )
}
